import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { createContext, ReactNode, useContext, useEffect, useState } from "react";

// themas do MUI
const lightTheme = createTheme({
    palette: {
        mode: "light",
        background: {
            default: 'var(--background-color)',
            paper: "#ffffff",
        },
        text: {
            primary: 'var(--font-color)',
        },
    },
});

const darkTheme = createTheme({
    palette: {
        mode: "dark",
        background: {
            default: 'var(--background-color)',
            paper: "#303030",
        },
        text: {
            primary: 'var(--font-color)',
        },
    },
});


interface ThemeContextType {
    themeMode: "light" | "dark";
    toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
    const [themeMode, setThemeMode] = useState<"light" | "dark">(
        (localStorage.getItem("theme") as "light" | "dark") || "light"
    );

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", themeMode);
        document.documentElement.setAttribute("data-bs-theme", themeMode);
        localStorage.setItem("theme", themeMode);
    }, [themeMode]);

    const toggleTheme = () => {
        setThemeMode((prev) => (prev === "light" ? "dark" : "light"));
    };

    return (
        <ThemeContext.Provider value={{ themeMode, toggleTheme }}>
            <ThemeProvider theme={themeMode === "light" ? lightTheme : darkTheme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </ThemeContext.Provider>
    );
};

// Hook para usar o tema
export const useThemeContext = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error("useThemeContext deve ser usado dentro de ThemeProviderWrapper");
    }
    return context;
};
